import React, {CSSProperties, useEffect, useRef} from 'react';
import {ScadaTagProps} from "./scadaTypes";
import {durationSeconds} from "utils/time-utils";
import DatasetTooltipText from "../../basic/dataset-tooltip-text/DatasetTooltipText";
import {Tooltip} from "react-tooltip";

import 'react-tooltip/dist/react-tooltip.css'
import ReactDOM from 'react-dom';
import {formatDatasetValue} from "utils/value-format-utils";


const componentsStartSize: Record<number, number> = {
    1: 90.15,
    2: 224.328,
    3: 358.5,
    4: 492.66,
    5: 626.83,
    6: 761,
    7: 895.16,
    8: 1029.32,
    9: 1163.5,
    10: 1297.66,
    11: 1431.8,
    12: 1566
}

export function ScadaTag(props: ScadaTagProps) {
    const ref = useRef<HTMLDivElement>(null);

    const id = `scada-label-${props.identifier.split(':')[1]}-${props.identifier.split(':')[0]}`
    const dataset = props.dataset;
    const loading = !dataset;

    const data = (dataset?.data.length! | 0) > 0 ? dataset?.data[0] : null;
    const time = data?.key ? new Date(data.key as string) : null;


    const delayDuration = durationSeconds(props.model.maxDelayTime, props.model.maxDelayTimeUnit)

    const noData = !(data!);
    const staleTag = (+(props.refTime || new Date()) - +time!!) / 1000 > delayDuration;

    const bgColor = getTagColor(props, loading, noData, staleTag);

    const tagStyle = {
        left: `${props.x}%`,
        top: `${props.y}%`,
        whiteSpace: "pre-wrap",
    } as CSSProperties;


    useEffect(() => {
        console.log(id)
        if (ref?.current) {
            ref.current.dataset["identifier"] = props.identifier;
        }
    }, [ref])


    useEffect(() => {
        if (props.dataset && ref?.current) {
            ref.current.dataset["title"] = props.dataset.title as string;
        }
    }, [props.dataset])

    // const tagCopy = (e: KeyboardEvent) => {
    //     if(e.ctrlKey && e.key.toLowerCase() === "c")
    //
    //     if(dataset?.title){
    //         textToClipboard(dataset?.title);
    //         PF('globalGrowl').renderMessage(
    //             {
    //                 "summary":"Copied SCADA tag",
    //                 "detail": dataset?.title,
    //                 "severity":"info"
    //             }
    //         );
    //     }
    // }

    const onClick = (e: any) => {
        if (e.ctrlKey) {
            const scadaLabelsGlobal = window.scada.selectedLabels;
            const el = ref?.current;
            el!!.classList.add("selectedLabel");
            scadaLabelsGlobal.push(el);
            window.scada.lastClick = new Date().getTime();
        }
    }

    const onDbClick = () => {
        const scadaLabelsGlobal = window.scada.selectedLabels;
        const el = ref?.current;
        el!!.classList.add("selectedLabel");
        scadaLabelsGlobal.push(el);
        props.model.openDialogCallBack()
    }

    const calculateLabelTransform = (imageWidth: number, componentSize: number) => {
        return imageWidth / componentsStartSize[componentSize];
    }

    const tooltipContainer = document.getElementById("tooltip-container")

    return <>
        <div id={id}
             ref={ref}
             onClick={onClick}
             onDoubleClick={onDbClick}
             className="scada-label"
             style={{...tagStyle,
                 backgroundColor: bgColor,
                 fontSize: `${props.fontSize}px`,
                 transform: `scale(${calculateLabelTransform(props.model.imageWidth, props.model.size)})`,
                 transformOrigin: "top left",
        }}
        >
            {loading &&
                <>
                    <span style={{whiteSpace: "pre-wrap"}}>   <i className="pi pi-spin pi-spinner"></i>   </span>
                </>
            }

            {!loading && !noData &&
                <>
                    <span className="measValue" style={{fontSize: "inherit"}}>{formatDatasetValue(dataset, data)}</span>
                    <span className="measDimm"> {dataset.unit}</span>
                </>
            }

            {!loading && noData &&
                <>
                    <span className="measValue" style={{fontSize: "inherit"}}>N/A</span>
                    <span className="measDimm"> {dataset.unit}</span>
                </>
            }
        </div>
        {tooltipContainer && !loading && ReactDOM.createPortal(
            <Tooltip anchorSelect={`#${id}`} style={{zIndex: 99999}}>
                <DatasetTooltipText data={data} time={time!!} dataset={dataset!!} hide={loading}/>
            </Tooltip>,
            tooltipContainer
        )}

    </>
}

function getTagColor(props: ScadaTagProps, loading: boolean, noData: boolean, stale: boolean) {
    if (loading) {
        return "#b0fc8b";
    } else if (noData || stale) {
        return "#fd6565";
    } else {
        return `#${props.bgColor}`;
    }
}